export default ({ request }) => ({
    dfDefinitionListApi(data = {}) {
        return request({
            url: '/dfs/df/definition/list',
            method: 'post',
            data,
        })
    },
    dfDefinitionSaveApi(data = {}) {
        return request({
            url: '/dfs/df/definition/save',
            method: 'post',
            data,
        })
    },
    dfDefinitionCopyApi(data = {}) {
        return request({
            url: '/dfs/df/definition/copy',
            method: 'post',
            data,
        })
    },
    dfDefinitionDetailApi(data = {}) {
        return request({
            url: '/dfs/df/definition/detail',
            method: 'post',
            data,
        })
    },
    dfDefinitionDelApi(data = {}) {
        return request({
            url: '/dfs/df/definition/del',
            method: 'post',
            data,
        })
    },
    dfDefinitionEnableApi(data = {}) {
        return request({
            url: '/dfs/df/definition/enable',
            method: 'post',
            data,
        })
    },
    dfDefinitionDisableApi(data = {}) {
        return request({
            url: '/dfs/df/definition/disable',
            method: 'post',
            data,
        })
    },
    dfDefinitionCategoryListApi(data = {}) {
        return request({
            url: '/dfs/df/definition/category/list',
            method: 'post',
            data,
        })
    },
    dfDefinitionCategorySaveApi(data = {}) {
        return request({
            url: '/dfs/df/definition/category/save',
            method: 'post',
            data,
        })
    },
    dfsDfDefinitionItemListApi(data = {}) {
        return request({
            url: '/dfs/df/definition/item/list',
            method: 'post',
            data,
        })
    },
    dfsDfDefinitionItemDelApi(data = {}) {
        return request({
            url: '/dfs/df/definition/item/del',
            method: 'post',
            data,
        })
    },
    dfsDfDefinitionItemDetailApi(data = {}) {
        return request({
            url: '/dfs/df/definition/item/detail',
            method: 'post',
            data,
        })
    },
    dfsDfDefinitionItemSaveApi(data = {}) {
        return request({
            url: '/dfs/df/definition/item/save',
            method: 'post',
            data,
        })
    },
    dfsDfDefinitionItemColumnApi(data = {}) {
        return request({
            url: '/dfs/df/definition/item/column',
            method: 'post',
            data,
        })
    },
    dfsDfDefinitionItemValueDefectSeverityApi(data = {}) {
        return request({
            url: '/dfs/df/fefinition/item/value/defect/severity',
            method: 'post',
            data,
        })
    },
})
